import {
  deleteDependenceDad,
  getDependencies,
  updateDependecies,
  deleteItemFromDependencies
} from '../indexDB/dependencies.js';

import { mapActions } from "vuex"

import { getAllQuestion, setQuestion, setCounter, getAllPages } from '../indexDB/logic.js';
export default {
  methods: {
    ...mapActions("resource", ["getCreatedDependencies"]),
    /**
     * Elimina una pregunta del diseñador
     */
    async deleteQuestion () {
      const nameDad = this.question.name;
      await deleteDependenceDad(nameDad);
      await this.DELETE_QUESTION(this.index);
      setQuestion();
      await this.reorganizarIndex(nameDad);
      const allPages = await getAllPages();
      this.UPDATE_STATE({ key: 'allPages', value: allPages });
      this.getCreatedDependencies();
    },
    /**
     * Devuelve un objeto con la relación del ID de la pregunta (P_X) y su posición dentro del array de preguntas.
     * @returns { Object } - Objeto con la relación ID de la pregunta (P_X) y su indice dentromdel array de prguntas.
     */
    async creteIndex () {
      const result = await getAllQuestion();
      const object = {};
      for (const i in result) object[result[i].name] = parseInt(i);
      return object;
    },
    /**
     * Reorganiza los indices de las preguntas hijas para las diferentes dependencias.
     * @param {string} nameDad - ID de la pregunta padre
     */
    async reorganizarIndex (nameDad = null) {
      const { compound, simple, listener } = await getDependencies();
      const newCreated = await this.reorganizateCreate(simple, nameDad);
      await setQuestion();
      const newCompound = await this.reorganizateCompound(compound, nameDad);

      const newListener = await this.reorganizateListener(listener, nameDad);
      updateDependecies(newCreated, newCompound, newListener);
    },
    async reorganizateCreate (create, child = null) {
      const listIndex = await this.creteIndex();
      for (const i in create) {
        for (const j in create[i]) {
          if (j === child) {
            delete create[i][j];
            if (Object.entries(create[i]).length === 0) delete create[i];
          } else create[i][j].question = listIndex[create[i][j].name];
        }
      }
      return create;
    },
    /**
     * Se desvincula una pregunta de la dependencia compuesta y se reorganiza los indices de las preguntas restantesque estan vinculadas todavia
     * @param {Object} compound
     * @param {*} child - ID de la pregunta (P_X)
     * @returns
     */
    async reorganizateCompound (compound, child = null) {
      //ELIMINAMOS EL ITEM DE LAS ANSWERS
      if (child) {
        for (const i in compound) {
          for (const j in compound[i].answers) {
            const item = compound[i]['answers'][j];
            if (item.name === child) {
              delete compound[i]['answers'].splice(j, 1);
              if (compound[i]['answers'].length === 0) {
                await deleteItemFromDependencies(i);
                delete compound[i];
              }
            }
          }
        }
      }

      //REORGANIZAMOS LOS INDICES PARA CADA PREGUNTA DEL ANSWERS
      const listIndex = await this.creteIndex();
      for (const i in compound) {
        for (const j in compound[i].answers) {
          compound[i]['answers'][j].question = listIndex[compound[i]['answers'][j].name];
        }
      }
      return compound;
    },
    /**
     * Reorganiza las depednecias de tipo listener.
     * @param { Object } listener - Es un objeto con todas las depenmdencias listener.
     * @returns { Object } - retorna un objeto con la dependencias listner organizadas.
     */
    async reorganizateListener (listener) {
      const listIndex = await this.creteIndex();
      const newListener = {};
      for (const i in listener) {
        newListener[i] = { ...listener[i] };
        newListener[i].related.question = listIndex[listener[i].related.name];
      }

      return newListener;
    },
    /**
     * Realiza un duplicado de una pregunta.
     */
    async copyQUestion () {
      const Copy = {};
      for (const i in this.question) {
        if (Array.isArray(this.question[i])) Copy[i] = [...this.question[i]];
        if (typeof this.question[i] === 'object' && !Array.isArray(this.question[i])) Copy[i] = { ...this.question[i] };
        if (typeof this.question[i] !== 'object') Copy[i] = this.question[i];
      }

      Copy.name = `P_${this.counter}`;

      const payload = {
        question: Copy,
        position: this.index
      };
      this.COPY_QUESTION(payload);
      await setQuestion();
      await setCounter();

      await this.reorganizarIndex();
      const allPages = await getAllPages();
      this.UPDATE_STATE({ key: 'allPages', value: allPages });
    }
  }
};
